<template>
  <div id="app">
    <h1>Générateur de nom d'hébergeur bien de chez nous</h1>
    <Generator></Generator>
  </div>
</template>

<script>
import Generator from "./components/Generator";

export default {
  name: 'App',
  components: {
    Generator
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
